import $ from "jquery";
import Template from "./CallbackPopup.ejs";
import makeTemplateFunc from "lodash/template";

const TemplateFunc = makeTemplateFunc(Template);

class CallbackPopup {

    constructor() {
        $(document).on('click', '.js-order-call', (e) => {
            e.preventDefault();
            this.apiUrl = $('.js-order-call').data('form-api');
            this.openPopup();
        })
    }

    openPopup() {
        const popupTemplate = TemplateFunc();
        const apiUrl = this.apiUrl;

        if ($('#callback').length  === 0) {
            $(popupTemplate).appendTo('body');
        }
        $('#callback').addClass('open');
        $('.modal-bg').fadeIn().addClass('open');

        $('#personal-phone').mask("+7 (999) 999-99-99");

        $('#callback-form').validate({
            errorClass: "error",
            validClass: "success",
            errorElement: "em",
            focusInvalid: false,
            rules: {
                name: {
                    required: true
                },
                phone: {
                    required: true
                }
            },
            messages: {
                name: {
                    required: ""
                },
                phone: {
                    required: ""
                }
            },
            invalidHandler: function (event, validator) {
                var errors = validator.numberOfInvalids();
                if (errors) {
                }
            },
            submitHandler: function() {
                $.ajax({
                    url: apiUrl,
                    method: 'POST',
                    data: {
                        name: $("#name").val(),
                        phone: $("#personal-phone").val()
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.error) {
                            console.error(data);
                        } else {
                            $('.modal.open').removeClass('open');
                            $('#callback-success').addClass('open');
                        }
                    },
                    error: function (data) {
                        console.error(data);
                    }
                });
            },
            highlight: function(element, errorClass, validClass) {
                $(element).addClass(errorClass).removeClass(validClass);

            },
            unhighlight: function(element, errorClass, validClass) {
                $(element).removeClass(errorClass).addClass(validClass);
            },

            errorPlacement: function(error, element) {

            }
        });
    }
}

export default new CallbackPopup();


// WEBPACK FOOTER //
// ./js/components/CallbackPopup/CallbackPopup.js